import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { selectAllies, selectIsGameFinished } from "src/store/game"

import "./TradeButton.css"

// Trading only means anything with a teammate to trade with, so in a 1v1 this is not a disabled
// button — it is nothing at all. The backend agrees: giving to yourself raises NotAnAlly.
const TradeButton = ({ disabled = false }) => {
  const { t } = useTranslation()
  const allies = useSelector(selectAllies)
  const isFinished = useSelector(selectIsGameFinished)

  if (isFinished || allies.length === 0) return null

  return (
    <button className="aid-button" disabled={disabled} onClick={() => ModalService.show("TradeModal")}>
      {t("game.trade.sendAid")}
    </button>
  )
}

export default TradeButton
